import axios from "axios";
import Vue from "vue";
import utils from "@/utils";
import { gunzipSync } from "fflate";
import { Buffer } from "buffer";
import { DateTime } from "luxon";

const state = {
  /**
   * Logy vozidla
   */
  logs: [],

  /**
   * Aktuální log.
   */
  log: null,

  fetching: false,
  fetched: false,
  running: null
};

const getters = {
  getLogs: (state) => {
    return state.logs;
  },
  getLog: (state) => {
    return state.log;
  }
};

const actions = {
  clear({ commit }) {
    commit("clear");
  },

  // eslint-disable-next-line no-unused-vars
  fetchLogs({ commit, state, dispatch }, params) {
    // pokud se vozidla právě vyčítaji, nic nedělěj
    if (state.fetching)
      return Promise.resolve();

    let tid;

    // zavolame stazeni objektu, ktere az se provede, tak se objekt ulozi
    const promise = dispatch("progress/add", "Fetch record", { root: true })
      .then(id => {
        tid = id;
        return axios.get(`/v1/admin/vehicle-logs/${params.vehicleId}`);
      }).then((response) => {
        commit("logsFetched", { logs: response.data });
        return state.vehicles;
      }).catch((error) => {
        commit("logsFetched", { logs: [] });
        console.log("Vehicle logs fetch error", error);
        return undefined;
      }).finally(() => dispatch("progress/remove", tid, { root: true }));

    // nastavime, ze se objekt s touto URL uz stahuje, aby se to neptalo nekolikrat
    commit("beginFetching");
    return promise;
  },

  // eslint-disable-next-line no-unused-vars
  fetchLog({ commit, state, dispatch }, params) {
    // pokud se vozidla právě vyčítaji, nic nedělěj
    if (state.fetching)
      return Promise.resolve();

    let tid;

    // zavolame stazeni objektu, ktere az se provede, tak se objekt ulozi
    const promise = dispatch("progress/add", "Fetch record", { root: true })
      .then(id => {
        tid = id;
        return axios.get(`/v1/admin/vehicle-log/${params.vehicleId}?date=${encodeURIComponent(DateTime.fromISO(params.date).toFormat(utils.API_DFORMAT))}`,
          {
            responseType: "arraybuffer"
          });
      }).then((response) => {
        commit("logFetched", {
          log: (new TextDecoder().decode(gunzipSync(Buffer.from(response.data, "binary"))).replaceAll("\n", "\n\n"))
        });
        /*commit("logFetched", {
          log: (new TextDecoder().decode(pako.ungzip(Buffer.from(response.data, "binary")))).replaceAll("\n", "\n\n")
        });*/
        return state.logs;
      }).catch((error) => {
        commit("logFetched", { log: null });
        console.log("Vehicle logs fetch error", error);
        return undefined;
      }).finally(() => dispatch("progress/remove", tid, { root: true }));

    // nastavime, ze se objekt s touto URL uz stahuje, aby se to neptalo nekolikrat
    commit("beginFetching");
    return promise;
  }
};

const mutations = {
  logsFetched(state, params) {
    params.logs.sort((x, y) => new Date(y) - new Date(x));
    Vue.set(state, "logs", params.logs);

    Vue.set(state, "fetching", false);
    Vue.set(state, "fetched", true);
  },

  logFetched(state, params) {
    Vue.set(state, "log", params.log);

    Vue.set(state, "fetching", false);
    Vue.set(state, "fetched", true);
  },

  clear(state) {
    Vue.set(state, "log", null);
    Vue.set(state, "logs", []);
  },

  /**
   * Nastaví začátek stahování
   */
  beginFetching(state) {
    Vue.set(state, "fetching", true);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};